// extracted by mini-css-extract-plugin
export default {"products":"uu-z","card":"vu-z","oosMessaging":"wu-z"};